var map = {
	"./ar.svg": 91822,
	"./de.svg": 7254,
	"./el.svg": 33324,
	"./en.svg": 74414,
	"./es.svg": 42971,
	"./et.svg": 27700,
	"./fr.svg": 54563,
	"./it.svg": 8824,
	"./lt.svg": 29423,
	"./lv.svg": 78941,
	"./nl.svg": 88493,
	"./pl.svg": 51995,
	"./ro.svg": 65746,
	"./ru.svg": 63160,
	"./uk.svg": 78723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41723;